import { useTranslation } from 'react-i18next'
import { useContextScreensaver } from '../../contexts/screensaverContext'

const LanguageChanger = () => {
  const { t, i18n } = useTranslation()
  const { setIsScreensaverOn } = useContextScreensaver()

  const changeLanguage = () => {
    setIsScreensaverOn(false)
    i18n.changeLanguage(i18n.language === 'hu' ? 'en' : 'hu')
  }

  return (
    <button
      className="fixed bottom-0 left-0 z-[2] h-[38px] w-[65px] rounded-tr-[20px] border-0 bg-white p-0 text-center font-approach-medium text-[9px] uppercase leading-[24px] tracking-[0.65px] shadow-floating md:h-[45px] md:w-[80px] md:rounded-tr-[24px] md:text-[11px] xl:h-[70px] xl:w-[122px] xl:rounded-tr-[39px] xl:text-[19px] xxl:bottom-[6vh] xxl:left-[3vw] xxl:rounded-[17px]"
      onClick={changeLanguage}
    >
      <span className="text-[1em]">{t('changeLanguage')}</span>
    </button>
  )
}

export default LanguageChanger
